import { observer } from 'mobx-react-lite';
import ParcelTaxesInfo from '../../features/parcel-creation/parcel-taxes-info/parcel-taxes-info';
import ParcelItemsManagement from '../../features/parcel-creation/parcel-items-management/parcel-items-management.component';
import { useStore } from '../../stores/store';
import { EditFormProvider } from '../../features/parcel-creation/parcel-items-management/edit-form-manager';
import InsuranceFeeSimplified from '../../features/parcel-creation/insurance-fee/insurance-fee-simplified';

const ParcelContent = () => {
  const {
    parcelCreationStore: { shipment, navigation },
  } = useStore();

  return (
    <>
      <EditFormProvider navigation={navigation}>
        <ParcelItemsManagement />
      </EditFormProvider>
      {/* {!showSimplifiedInsurance && <InsuranceFee />} */}
      <InsuranceFeeSimplified />
      <ParcelTaxesInfo shipment={shipment} />
    </>
  );
};

export default observer(ParcelContent);
